import SearchAndSelect from "../SearchAndSelect";
import { useQuery } from "react-query"
import { usersGroupsFilterFn } from "../../../services/user";

const UserGroupSelect = ({ formik, name, label, setValue, value, error, helpText }) => {
    const { data, isLoading } = useQuery("users-group-list-filter", () => usersGroupsFilterFn());
    const groups = data?.map((i) => ({ label: i.description, value: i.id }));

    const handleSelectOption = async (id) => {
        const item = await data.find((i) => i?.id === id);
        setValue(item);
    }

    return <SearchAndSelect 
                name={name} 
                setValue={handleSelectOption} 
                value={value} 
                placeholder="Selecione uma opção" 
                label={label || "Setor"} 
                options={groups || []} 
                formik={formik} 
                loading={isLoading} 
                fullWidth
                className="mb-2"
                error={error}
                helpText={helpText}
            />
};
  

export default UserGroupSelect;